import * as React from "react";
import { SVGProps } from "react";
export const MinusSquareIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.75 10.75H12.25C12.4625 10.75 12.6406 10.6785 12.7844 10.5356C12.9281 10.3927 13 10.2156 13 10.0044C13 9.79313 12.9281 9.61458 12.7844 9.46875C12.6406 9.32292 12.4625 9.25 12.25 9.25H7.75C7.5375 9.25 7.35938 9.32145 7.21563 9.46435C7.07188 9.60727 7 9.78435 7 9.9956C7 10.2069 7.07188 10.3854 7.21563 10.5312C7.35938 10.6771 7.5375 10.75 7.75 10.75ZM4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V4.5C3 4.0875 3.14687 3.73438 3.44062 3.44063C3.73437 3.14688 4.0875 3 4.5 3H15.5C15.9125 3 16.2656 3.14688 16.5594 3.44063C16.8531 3.73438 17 4.0875 17 4.5V15.5C17 15.9125 16.8531 16.2656 16.5594 16.5594C16.2656 16.8531 15.9125 17 15.5 17H4.5ZM4.5 15.5H15.5V4.5H4.5V15.5Z"
            fill="currentColor"
        />
    </svg>
);
MinusSquareIcon.displayName = "MinusSquareIcon";
